import SingleSelectField from './SingleSelectField';
import MultiSelectField from './MultiSelectField';
import ImageField from './ImageField';
import TextField from './TextField';
import TextAreaField from './TextAreaField';
import NumberField from './NumberField';
import Table from './Table';
import FieldGroup from './FieldGroup';
import SectionsSummary from './SectionsSummary';
import DateTimeField from './DateTimeField';
import SwitchField from './SwitchField';
import SwitchSummaryField from './SwitchSummaryField';
import Accordion from './Accordion';
import AccordionGroup from './AccordionGroup';
import Note from './Note';
import Divider from './Divider';
import Modal from './Modal';
import SegmentsField from './SegmentsField';
import HiddenField from './HiddenField';
import SelectModalField from './SelectModalField';
import TableModalField from './TableModal';
import SummaryItemsField from './SummaryItems';
import PreviousSelectField from './PreviousSelectField';
import ContestCardsField from './PreviousSelectField/ContestCardsField';
import TabField from './TabField';
import PillField from './PillField';
import MultiSelectModalField from './MultiSelectModalField';
import UploadImageField from './UploadImageField';
import UneditableSettingsFields from './UneditableSettingsFields';
import BannerField from './Banner/Banner';
import FieldErrorNote from './FieldErrorNote/FieldErrorNote';
import EditModalField from './EditModalField';
import FlexibleDoublePicksField from './FlexibleDoublePicksField';
import SelectModalFieldWithCustom from './SelectModalFieldWithCustom';
import RadioGroupField from './RadioGroupField';
import WarningNote from './WarningNote/WarningNote';

const StaticFieldDescriptors = [
  SingleSelectField,
  MultiSelectField,
  ImageField,
  TextField,
  TextAreaField,
  NumberField,
  Table,
  FieldGroup,
  SectionsSummary,
  DateTimeField,
  SwitchField,
  Accordion,
  AccordionGroup,
  Note,
  Divider,
  Modal,
  SegmentsField,
  HiddenField,
  SelectModalField,
  SwitchSummaryField,
  TableModalField,
  SummaryItemsField,
  PreviousSelectField,
  ContestCardsField,
  TabField,
  PillField,
  MultiSelectModalField,
  UploadImageField,
  UneditableSettingsFields,
  BannerField,
  FieldErrorNote,
  EditModalField,
  FlexibleDoublePicksField,
  SelectModalFieldWithCustom,
  RadioGroupField,
  WarningNote,
];

type StaticFieldDescriptorsMapType = {
  SingleSelectField: typeof SingleSelectField;
  MultiSelectField: typeof MultiSelectField;
  ImageField: typeof ImageField;
  TextField: typeof TextField;
  TextAreaField: typeof TextAreaField;
  NumberField: typeof NumberField;
  Table: typeof Table;
  FieldGroup: typeof FieldGroup;
  SectionsSummary: typeof SectionsSummary;
  DateTimeField: typeof DateTimeField;
  SwitchField: typeof SwitchField;
  SwitchSummaryField: typeof SwitchSummaryField;
  Accordion: typeof Accordion;
  AccordionGroup: typeof AccordionGroup;
  Note: typeof Note;
  Divider: typeof Divider;
  Modal: typeof Modal;
  SegmentsField: typeof SegmentsField;
  HiddenField: typeof HiddenField;
  SelectModalField: typeof SelectModalField;
  TableModalField: typeof TableModalField;
  SummaryItemsField: typeof SummaryItemsField;
  PreviousSelectField: typeof PreviousSelectField;
  ContestCardsField: typeof ContestCardsField;
  PillField: typeof PillField;
  TabField: typeof TabField;
  MultiSelectModalField: typeof MultiSelectModalField;
  UploadImageField: typeof UploadImageField;
  UneditableSettingsFields: typeof UneditableSettingsFields;
  BannerField: typeof BannerField;
  FieldErrorNote: typeof FieldErrorNote;
  EditModalField: typeof EditModalField;
  FlexibleDoublePicksField: typeof FlexibleDoublePicksField;
  SelectModalFieldWithCustom: typeof SelectModalFieldWithCustom;
  RadioGroupField: typeof RadioGroupField;
  WarningNote: typeof WarningNote;
};

export const STATIC_FIELD_NAMES = StaticFieldDescriptors.map((field) => field.name);
export const StaticFieldDescriptorsMap: StaticFieldDescriptorsMapType =
  StaticFieldDescriptors.reduce((acc, field) => {
    acc[field.name] = field;
    return acc;
  }, {} as StaticFieldDescriptorsMapType);
